import {WhitelabelEvent, WhitelabelEventWithPayload} from "../../../../../../common/ts/events/Events";
import {SuccessEvent} from "../../../../../../common/ts/core/http";
import {
    SaveSearchModalInterface
} from "../../../../../../common/ts/components/modals/retention/SaveSearchModalInterface";

export class ShowRetentionCaptureModalRequestedEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'show-retention-capture-modal-requested'

    constructor() {
        this.type = ShowRetentionCaptureModalRequestedEvent.TYPE;
    }
}

export class ShowRetentionPopupMobileRequestedEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'show-retention-popup-mobile-requested';

    constructor() {
        this.type = ShowRetentionPopupMobileRequestedEvent.TYPE;
    }
}

export class EmptyEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'empty-event';

    constructor() {
        this.type = EmptyEvent.TYPE;
    }
}

interface SaveEmailAlertRequestedPayload {
    searches: string[],
    email: string,
    wantNews: boolean,
    successEvent?: SuccessEvent,
}

export class SaveEmailAlertRequestedEvent implements WhitelabelEventWithPayload<SaveEmailAlertRequestedPayload> {
    payload: SaveEmailAlertRequestedPayload;
    type: string;
    static readonly TYPE: string = 'save-email-alert-requested';

    constructor(payload: SaveEmailAlertRequestedPayload) {
        this.type = SaveEmailAlertRequestedEvent.TYPE;
        this.payload = payload;
    }
}

interface SaveSearchModalEventPayload {
    saveSearchModal: SaveSearchModalInterface;
}
export class ShowSaveSearchModalEvent implements WhitelabelEventWithPayload<SaveSearchModalEventPayload> {
    payload: SaveSearchModalEventPayload;
    type: string;
    static readonly TYPE: string = 'show-save-search-modal-event';

    constructor(payload: SaveSearchModalEventPayload) {
        this.type = ShowSaveSearchModalEvent.TYPE;
        this.payload = payload;
    }
}